import MainConnection from "./MainConnection";
import AlertManager from "../utils/AlertManager";

export default {
  requestNewsList: async function() {
    try {
      const requestURL = "/news";
      const response = await MainConnection.request().get(requestURL);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestNewsInfoById: async function(news_id) {
    try {
      const requestURL = "/news/" + news_id;
      const response = await MainConnection.request().get(requestURL);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestCreateNews: async function(params) {
    try {
      const requestURL = "/news";
      const response = await MainConnection.request().post(requestURL, params);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestUpdateNews: async function(news_id, params) {
    try {
      const requestURL = "/news/" + news_id;
      const response = await MainConnection.request().patch(requestURL, params);

      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  removeNewsById: async function(news_id) {
    try {
      const requestURL = "/news/" + news_id;
      const response = await MainConnection.request().delete(requestURL);

      switch (response.data.code) {
        case "0":
          return true;

        default:
          AlertManager.showErrorDialog(
            response.data.code,
            response.data.message
          );
          return false;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
